import React from "react";
import { useLocation } from "react-router-dom";
import { FaBell, FaUserCircle, FaCog } from "react-icons/fa";
import "../css/Header.css";

const Header = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tenant_name =
    params.get("tenant_name") || localStorage.getItem("tenantName");
  const tenant_email =
    params.get("tenant_email") || localStorage.getItem("tenantEmail");
  return (
    <header className="app-header">
      {/* Left: Title */}
      <div className="header-left">
        <span className="header-title">Epic-X Whatsapp</span>
      </div>

      {/* Center: Tagline */}
      <div className="header-center">
        <p className="header-tagline">
          A powerful WhatsApp Business platform to grow your online sales
        </p>
      </div>

      {/* Right: Icons */}
      <div className="header-right">
        <button className="icon-btn" type="button" aria-label="Notifications">
          <FaBell size={18} />
        </button>
        <button className="icon-btn" type="button" aria-label="Settings">
          <FaCog size={18} />
        </button>
        <button className="profile-btn" type="button" aria-label="Profile menu">
          <FaUserCircle size={22} />
        </button>
      </div>
    </header>
  );
};

export default Header;
